import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ViewRequestRoutingModule } from './view-request-routing.module';
import { IsbComponent } from './isb/isb.component';
import {ToolbarModule} from 'src/app/layout/toolbar/toolbar.module';
import {IconsModule} from 'src/app/icons/icons.module';
import {TableModule} from 'src/app/table/table.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ErrorModule} from 'src/app/components/error/error.module';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {SharedModule} from 'src/app/shared/shared.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {PaginatorModule} from 'src/app/components/paginator/paginator.module';
import { IsbPackageComponent } from './isb-package/isb-package.component';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import { MatSelectModule } from '@angular/material/select';
import { ComingSoonModule } from 'src/app/main/coming-soon/coming-soon.module';


@NgModule({
  declarations: [
    IsbComponent,
    IsbPackageComponent
  ],
  imports: [
    CommonModule,
    ViewRequestRoutingModule,
    ToolbarModule,
    IconsModule,
    TableModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorModule,
    MatIconModule,
    MatCardModule,
    SharedModule,
    MatProgressSpinnerModule,
    PaginatorModule,
    SidenavHeaderModule,
    MatSelectModule,
    ComingSoonModule,
  ],
})
export class ViewRequestModule { }
